import * as CL from '@design-system/component-library';
import { RecordInput } from './RecordInput.js';
import { validateIPv4 } from './fieldValidation.js';

export const AValueField = ({ index }: { index: number }) => (
  <CL.GridCol colsXS={4}>
    <RecordInput name="value" validate={validateIPv4} index={index} />
  </CL.GridCol>
);
